'use client';

import type { ReactNode } from 'react';
import { VStack } from '@terra/ui-styled-system';
import { MetaDefault } from '../../../../../components/typography';
import { MinimalToolCard } from '../../MinimalToolCard';
import type { CardRenderContext } from '../../tool-config-types';
import { AdGraphListBody } from './ad-graph-list-body';
import {
  adGraphVisualizationToParsedOutput,
  readAdGraphVisualization,
} from './ad-graph-visualization.utils';

export const renderAdGraphVisualizationCard = (
  ctx: CardRenderContext,
): ReactNode => {
  const visualization = readAdGraphVisualization(
    ctx.toolCallData.output,
    ctx.toolCallData.input,
  );
  const canShowGraph =
    ctx.toolCallData.status === 'completed' && Boolean(visualization);

  if (canShowGraph && visualization) {
    return (
      <VStack alignItems="stretch" gap={2} width="100%">
        {visualization.description ? (
          <MetaDefault color="fg.muted">
            {visualization.description}
          </MetaDefault>
        ) : null}
        <AdGraphListBody
          graph={adGraphVisualizationToParsedOutput(visualization)}
        />
      </VStack>
    );
  }

  const durationMs = ctx.toolCallData.timing?.durationMs;

  return (
    <MinimalToolCard
      icon={ctx.toolIcon}
      toolName={
        ctx.toolCallData.status === 'started' ||
        ctx.toolCallData.status === 'in-progress'
          ? ctx.labelPresent
          : ctx.labelPast
      }
      status={ctx.toolCallData.status}
      timing={typeof durationMs === 'number' ? { durationMs } : undefined}
      error={ctx.toolCallData.error}
      autoCollapseWhenComplete={ctx.autoCollapseWhenComplete}
    />
  );
};
